/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CommitLineupLockChangesInput = {|
  lineupLockChanges?: ?$ReadOnlyArray<?LineupLockInput>,
  clientMutationId?: ?string,
|};
export type LineupLockInput = {|
  gmLineupId: string,
  locked: boolean,
|};
export type ViewLineupsAllLineupLockMutationVariables = {|
  input: CommitLineupLockChangesInput
|};
export type ViewLineupsAllLineupLockMutationResponse = {|
  +commitLineupLockChanges: ?{|
    +success: ?boolean
  |}
|};
export type ViewLineupsAllLineupLockMutation = {|
  variables: ViewLineupsAllLineupLockMutationVariables,
  response: ViewLineupsAllLineupLockMutationResponse,
|};
*/


/*
mutation ViewLineupsAllLineupLockMutation(
  $input: CommitLineupLockChangesInput!
) {
  commitLineupLockChanges(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CommitLineupLockChangesPayload",
    "kind": "LinkedField",
    "name": "commitLineupLockChanges",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ViewLineupsAllLineupLockMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ViewLineupsAllLineupLockMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8952cc71b985bf4c1fbc681ecfa90948",
    "id": null,
    "metadata": {},
    "name": "ViewLineupsAllLineupLockMutation",
    "operationKind": "mutation",
    "text": "mutation ViewLineupsAllLineupLockMutation(\n  $input: CommitLineupLockChangesInput!\n) {\n  commitLineupLockChanges(input: $input) {\n    success\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'e3b71bbabb17582dd6437fc1b56d48e0';

module.exports = node;
